import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { X, AlertOctagon } from "lucide-react";

export default function LossModal({ open, lead, onClose, onSaved }) {
  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  React.useEffect(() => {
    if (!open) return;
    setErr(""); setReason(""); setRemarks("");
  }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) { setErr("Reason for loss is mandatory"); return; }
    setSaving(true);
    try {
      await api.post(`/sales/leads/${lead.id}/mark-loss`, { reason: reason.trim(), remarks });
      toast.success("Marked as Loss");
      onSaved();
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Failed");
    } finally {
      setSaving(false);
    }
  };

  if (!open || !lead) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-testid="loss-modal">
      <div className="w-full max-w-md iz-card p-8 relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 p-1.5 rounded hover:bg-[#1c1c1c] text-gray-500"><X className="w-4 h-4"/></button>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center">
            <AlertOctagon className="w-4 h-4 text-red-400" strokeWidth={1.5}/>
          </div>
          <div>
            <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-red-400">Loss Gate</p>
            <h2 className="font-display text-xl text-white">Mark as loss</h2>
            <p className="text-[11px] text-gray-500 font-mono">{lead.client_name}</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-gray-400 mb-2">Reason *</label>
            <input value={reason} onChange={(e) => setReason(e.target.value)} className="iz-input" placeholder="e.g. Budget mismatch, competitor, no response" required data-testid="loss-reason"/>
          </div>
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-gray-400 mb-2">Tactical Remarks</label>
            <textarea rows={4} value={remarks} onChange={(e) => setRemarks(e.target.value)} className="iz-input" placeholder="Diagnostic notes for review queue" data-testid="loss-remarks"/>
          </div>

          {err && <div className="text-sm text-red-400 border border-red-500/30 bg-red-500/5 rounded-md px-3 py-2">{err}</div>}

          <div className="flex justify-end gap-3 pt-4 border-t border-[#1a1a1a]">
            <button type="button" onClick={onClose} className="iz-btn-secondary">Cancel</button>
            <button type="submit" disabled={saving} className="iz-btn-danger px-4 py-2" data-testid="loss-submit">
              {saving ? "Saving…" : "Mark Loss"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
